import Image from 'next/image';
import { useState } from 'react';

import { fontStyles } from '@/styles/typography';

import { classNames } from '@/utils/classnames';

import { sectionTitleClass } from '../shared-styles';

const SYSTEM_PREVIEW_NUMBERS = 7;

const cardClass = classNames(
  'flex',
  'flex-col',
  'items-center',
  'rounded-md',
  'border-1',
  'border-token-gray-300',
  'bg-token-gray-100',
  'py-8',
  'w-full',
  'text-center',
  'justify-center',
  'tablet:justify-start',
  'tablet:px-6.5',
  'tablet:pt-7',
  'tablet:pb-11',
);

const whatIsMatchaPreviewClass = classNames(
  'rounded-md',
  'tablet:rounded-2xl',
  'desktop:rounded-[2.125rem]',
  'border-primitive-basic-white',
  'overflow-hidden',
  'h-auto',
  'z-1',
  'absolute',
  'm-0',
  'border-100',
  'shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05)]',
  'backdrop-blur-lg',
  'transition-[transform,margin,width]',
  'duration-200',
  'ease-linear',
  'origin-top-center',
  'rounded-b-none',
  'hidden',
  'data-[index=3]:block',
  'data-[index=3]:mt-0',
  'data-[index=3]:w-[80%]',
  'data-[index=3]:z-2',
  'data-[index=3]:rounded-[0.5rem]',
  'data-[index=3]:border-2',
  'data-[index=3]:hover:-mt-[10px]',
  'data-[index=2]:block',
  'data-[index=2]:-mt-[10px]',
  'data-[index=2]:w-[calc(80%*0.95)]',
  'data-[index=2]:z-1',
  'data-[index=2]:opacity-60',
  'data-[index=1]:block',
  'data-[index=1]:-mt-[20px]',
  'data-[index=1]:w-[calc(80%*0.9)]',
  'data-[index=1]:z-0',
  'data-[index=1]:opacity-30',
  'tablet:data-[index=3]:border-4',
  'tablet:data-[index=3]:w-[69%]',
  'tablet:data-[index=3]:rounded-[1rem]',
  'tablet:data-[index=2]:w-[calc(69%*0.95)]',
  'tablet:data-[index=1]:w-[calc(69%*0.9)]',
  'desktop:data-[index=3]:border-8',
  'desktop:data-[index=3]:rounded-[1.375rem]',
);

export const MatchaIndexSection = () => {
  const [previewImageIndex, setIndex] = useState(0);

  function onClick() {
    const nextImageIndex = (previewImageIndex + 1) % SYSTEM_PREVIEW_NUMBERS;
    setIndex(nextImageIndex);
  }

  return (
    <div className="overflow-hidden w-full mx-auto flex justify-center max-w-[1240px] gap-5 flex-col mt-23 mb-20">
      <div className="overflow-hidden w-full justify-center max-w-[1240px] gap-5 grid m-0 grid-rows-[repeat(4,auto)] grid-cols-[1fr] tablet:grid-rows-[repeat(2,auto)] tablet:grid-cols-[repeat(2,1fr)] desktop:grid-rows-[auto] desktop:grid-cols-[2fr_1fr_1fr_2fr]">
        <div className={classNames(cardClass, 'rounded-t-[2.25rem]', 'tablet:rounded-tr-md')}>
          <div className="h-9.5">
            <div className="flex center items-center border-token-gray-400 gap-2 pt-1 pr-3.25 pb-1 pl-1.5 text-300 border-2 rounded-[72px] bg-primitive-basic-white relative z-2">
              <Image
                alt="Example profile avatar"
                src="/images/about-us/profile-avatar.png"
                className="h-4.5 w-4.5"
                width={22}
                height={21}
              />
              <span>0x22..3D3D</span>
            </div>
            <div
              className={classNames(
                'w-full',
                'relative',
                'z-1',
                'after:content-[""]',
                'after:rounded-[0.5rem]',
                'after:border-token-gray-400',
                'after:border-2',
                'after:bg-primitive-basic-white',
                'after:absolute',
                'after:h-6',
                'after:w-[60%]',
                'after:bottom-[-8px]',
                'after:left-[20%]',
                'before:content-[""]',
                'before:rounded-[0.5rem]',
                'before:border-token-gray-400',
                'before:border-2',
                'before:bg-primitive-basic-white',
                'before:absolute',
                'before:h-6',
                'before:w-[80%]',
                'before:bottom-[-4px]',
                'before:left-[10%]',
                'before:z-1',
              )}
            ></div>
          </div>
          <div className="font-heading font-bold text-1600 mt-2 flex items-end text-primitive-basic-black leading-[78px]">
            +502
            <span className="text-token-gray-700 text-[50px] mb-[-3px]">k</span>
          </div>
          <div className="font-body text-token-gray-700 font-medium leading-6 text-[17px]">
            Wallets Traded
          </div>
        </div>

        <div
          className={classNames(cardClass, 'tablet:rounded-tr-[2.25rem]', 'desktop:rounded-tr-md')}
        >
          <div className="h-9.5">
            <div className="flex">
              <div className="w-6 h-6 rounded-full border-primitive-basic-white border-2 flex justify-center items-center shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05),0px_0px_0px_1px_rgba(0,0,0,0.06)] bg-[rgba(98,126,234,1)]">
                <Image
                  alt="Ethereum Icon"
                  src="/images/about-us/ethereum-icon.svg"
                  width={12}
                  height={16}
                />
              </div>
              <div className="w-6 h-6 rounded-full border-primitive-basic-white border-2 flex justify-center items-center shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05),0px_0px_0px_1px_rgba(0,0,0,0.06)] mt-[-3px] ml-[-4px] mr-[-4px] bg-[rgba(130,71,229,1)]">
                <Image
                  alt="Polygon Icon"
                  src="/images/about-us/polygon-icon.svg"
                  width={14}
                  height={12}
                />
              </div>
              <div className="w-6 h-6 rounded-full border-primitive-basic-white border-2 flex justify-center items-center shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05),0px_0px_0px_1px_rgba(0,0,0,0.06)] bg-[rgba(240,185,11,1)]">
                <Image
                  alt="BNB Icon"
                  src="/images/about-us/bnb-icon.svg"
                  width={26}
                  height={26}
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
          <div className="font-heading font-bold text-1600 mt-2 flex items-end text-primitive-basic-black leading-[78px]">
            +5
            <span className="text-token-gray-700 text-[50px] mb-[-3px]">m</span>
          </div>
          <div className="font-body text-token-gray-700 font-medium leading-6 text-[17px]">
            Tokens
          </div>
        </div>

        <div className={cardClass}>
          <div className="h-9.5">
            <div className="flex">
              <div className="w-6 h-6 rounded-full border-primitive-basic-white border-2 flex justify-center items-center shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05),0px_0px_0px_1px_rgba(0,0,0,0.06)] bg-[rgba(38,39,43,1)]">
                <Image
                  alt="0x protocol Icon"
                  src="/images/about-us/0x-protocol-icon.svg"
                  width={18}
                  height={18}
                />
              </div>
              <div className="w-6 h-6 rounded-full border-primitive-basic-white border-2 flex justify-center items-center shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05),0px_0px_0px_1px_rgba(0,0,0,0.06)] mt-[-3px] ml-[-4px] mr-[-4px] bg-[linear-gradient(230deg,#B6509E_15%,#2EBAC6_84%)]">
                <Image
                  alt="Aave Icon"
                  src="/images/about-us/aave-icon.svg"
                  width={24}
                  height={24}
                  className="w-full h-full"
                />
              </div>
              <div className="w-6 h-6 rounded-full border-primitive-basic-white border-2 flex justify-center items-center shadow-[0px_4px_42px_0px_rgba(0,0,0,0.06),0px_2px_6px_0px_rgba(0,0,0,0.05),0px_0px_0px_1px_rgba(0,0,0,0.06)] bg-[linear-gradient(180deg,#FEF2F9_0%,#FEE7F3_100%)]">
                <Image
                  alt="uniswap Icon"
                  src="/images/about-us/uniswap-icon.svg"
                  width={24}
                  height={24}
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
          <div className="font-heading font-bold text-1600 mt-2 flex items-end text-primitive-basic-black leading-[78px]">
            130+
          </div>
          <div className="font-body text-token-gray-700 font-medium leading-6 text-[17px]">
            liquidity sources
          </div>
        </div>
        <div
          className={classNames(
            'flex',
            'flex-col',
            'items-center',
            'rounded-md',
            'border-1',
            'border-token-gray-300',
            'bg-token-gray-100',
            'w-full',
            'text-center',
            'justify-center',
            'pb-16',
            'tablet:pb-11',
            'pt-18.5',
            'bg-[url("/images/about-us/trade-volume-icon.svg")]',
            'bg-no-repeat',
            'bg-bottom-right',
            'tablet:justify-start',
            'tablet:px-6.5',
            'desktop:rounded-tr-[2.25rem]',
          )}
        >
          <div className="font-heading font-bold text-1600 flex items-end text-primitive-basic-black leading-[78px]">
            +$62
            <span className="text-token-gray-700 text-[50px] mb-[-3px]">b</span>
          </div>
          <div className="font-body text-token-gray-700 font-medium leading-6 text-[17px]">
            Traded Volume
          </div>
        </div>
      </div>

      <div
        className="flex flex-col items-center rounded-md border-1 border-token-gray-300 bg-token-gray-100 pb-8 w-full text-center justify-center overflow-hidden relative pt-14.5 rounded-tr-md rounded-b-[2.25rem] tablet:justify-start tablet:px-6.5 tablet:pt-7 tablet:pb-11"
        style={{
          backgroundImage:
            "url('/images/about-us/whats-matcha-bkg-left.svg'), url('/images/about-us/whats-matcha-bkg-right.svg')",
          backgroundRepeat: 'no-repeat, no-repeat',
          backgroundPosition: 'top left, top right',
        }}
      >
        <div className={sectionTitleClass}>What is Matcha?</div>
        <div
          className={fontStyles({
            variant: 'BODY_LG',
            class: [
              'text-token-gray-800',
              'leading-6',
              'text-center',
              'mt-4',
              'px-12',
              'tablet:px-0',
              'max-w-[31rem]',
              'tablet:w-65%',
            ],
          })}
        >
          Matcha is a DEX aggregator. We aggregate liquidity from all across web3 to get the optimal
          price for your trade, no matter what you’re looking for.
        </div>
        <div
          className="flex justify-center bottom-0 w-full mt-6 cursor-pointer mb-[-20px] pb-[40vw] tablet:pb-[42%] desktop:pb-[40%] tablet:mb-[-100px] transform translate-y-[60px]"
          onClick={onClick}
        >
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(1 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-eth.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(2 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-matic.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(3 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-avax.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(4 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-bnb.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(5 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-arb.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(6 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-op.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
          <div
            className={whatIsMatchaPreviewClass}
            data-index={`${(7 + previewImageIndex) % SYSTEM_PREVIEW_NUMBERS}`}
          >
            <Image
              className="w-full h-auto border-token-alphalight-300 border-1 rounded-[.375rem] tablet:rounded-md desktop:rounded-[.875rem]"
              src="/images/about-us/matcha-system-preview-usdbc.png"
              width={1600}
              height={748}
              alt="What is Matcha Preview"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
